import { Component, Inject, PLATFORM_ID, OnInit, HostListener } from '@angular/core'
import { LayoutService } from './core/services/layout.service'
import { BehaviorSubject, Observable, Subscription } from 'rxjs'
import { CustomBreakpointNames } from './core/services/breakpoints.service'
import { isPlatformBrowser } from '@angular/common'
import { environment } from 'src/environments/environment'
import { NavigationEnd, NavigationStart, Router, RoutesRecognized } from '@angular/router'
import { filter, pairwise } from 'rxjs/operators'
import { NGXLogger } from 'ngx-logger'
import { LeaveSiteService } from './core/services/leave-site.service'

//import { DomSetAttributeLoggerService } from './modules/account/services/dom-logger.service'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  static isBrowser = new BehaviorSubject<boolean>(null)
  constructor(
    public router: Router,
   // private logger: NGXLogger,
   // private logger: DomSetAttributeLoggerService,
    
    private layoutService: LayoutService,
    public leaveSiteService: LeaveSiteService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    AppComponent.isBrowser.next(isPlatformBrowser(platformId))
      if (!isPlatformBrowser(platformId)) {
        return; // prevent DOM initialization in SSR
    }
  }
  sub: Subscription
  showModal
  title = 'icw-ui'
  detectRouterPath: string = ""
  breakpoints = {
    extraSmall: false,
    small: false,
    medium: false,
    large: true,
    extraLarge: true,
  }
  // google_url = `https://maps.googleapis.com/maps/api/js?key=${environment.MAPS_API_KEY}}&libraries=places&language=en`

   ngOnInit(){
      this.initialize();
  }


  private async initialize(): Promise<void> {
    /*  if (isPlatformBrowser(this.platformId)) {
        const $ = (await import('jquery')).default;
        (window as any).$ = $;
        (window as any).jQuery = $;

        await import('ngx-slick-carousel');
      } */

      this.router.events.subscribe((e) => {
        if (e instanceof NavigationEnd) {
          console.log('Router Path: ' + e.url);
          this.detectRouterPath =   e.url?.split("?")[0]?.replace("/","") 
        }
      });
      
      const commitDate = '10.26.26'
      const commitNo = '1'
      console.log(`version date: ${commitDate}\nbuild: ${commitNo}`)
      /*     this.sub = this.router.events.pipe(filter((evt: any) => evt instanceof RoutesRecognized)).subscribe((t) =>
        setTimeout(() => {
          this.addTegEvent()
        }, 1000)
      ) */
      this.layoutService.subscribeToLayoutChanges().subscribe(
        (observerResponse) => {
          this.breakpoints = this.layoutService.handleLayoutChanges()
        },
        (error: any) => {
          console.error(error)
        }
      )
  }

  logRouter(router: Router) {
    router.events
      .pipe(
        // The "events" stream contains all the navigation events. For this demo,
        // though, we only care about the NavigationStart event as it contains
        // information about what initiated the navigation sequence.
        filter((event: any) => {
          return event instanceof NavigationStart
        })
      )
      .subscribe((event: NavigationStart) => {
        // Every navigation sequence is given a unique ID. Even "popstate"
        // navigations are really just "roll forward" navigations that get
        // a new, unique ID.
        // The "navigationTrigger" will be one of:
        // --
        // - imperative (ie, user clicked a link).
        // - popstate (ie, browser controlled change such as Back button).
        // - hashchange
        // --
        // NOTE: I am not sure what triggers the "hashchange" type.

        // This "restoredState" property is defined when the navigation
        // event is triggered by a "popstate" event (ex, back / forward
        // buttons). It will contain the ID of the earlier navigation event
        // to which the browser is returning.
        // --
        // CAUTION: This ID may not be part of the current page rendering.
        // This value is pulled out of the browser; and, may exist across
        // page refreshes.
        if (event.restoredState) {
          console.warn('restoring navigation id:', event.restoredState.navigationId)
        }

        console.groupEnd()
      })
  }

  // @HostListener('window:beforeunload', ['$event'])
  // beforeunloadHandler(event:any) {
  //   event.returnValue = `You have unsaved changes, leave anyway?`;
  //   //I have used return false but you can your other functions or any query or condition
  // }

  ngAfterViewInit() {
    setTimeout(() => {
      this.addTegEvent()
    }, 1250)
  }

  addTegEvent() {
  if (isPlatformBrowser(this.platformId)) {
      let list = document.getElementsByTagName('a')
      let listLength = list.length
      for (let i = 0; i < listLength; i++) {
        list[i].addEventListener('click', (e) => this.leaveSite(e, i))
      }
    }
  
  }

  leaveSite(e, i) {
  if (isPlatformBrowser(this.platformId)) {
      let elem = e.target.href ? e.target : document.getElementsByTagName('a')[i]
      if (elem.href && !elem.href.includes(elem.baseURI.replace('https', '').replace('http', ''))) {
        if (elem.attributes['target'] && elem.attributes['target'].value) {
          this.leaveSiteService.onNewPage = true
        } else {
          this.leaveSiteService.onNewPage = false
        }

        if (elem.href && elem.href.includes('secure/disclosure')) {
          this.leaveSiteService.onNewPage = true
          this.leaveSiteService.showPopup = false
          window.open(elem.href, '_blank')
          e.preventDefault()
        } else {
          e.preventDefault()
          this.leaveSiteService.showPopup = true
          this.leaveSiteService.url = elem.href
        }

      } else {
        this.leaveSiteService.showPopup = false
      }
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe()
  }
}
